<div *ngIf="!mobile">
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'200'" [Cheight]="'84'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'200'" [Cheight]="'84'"></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'200'" [Cheight]="'84'"></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'200'" [Cheight]="'84'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'200'" [Cheight]="'84'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'200'" [Cheight]="'84'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'200'" [Cheight]="'84'" ></app-skeleton-loader>
  </div>
</div>

<div *ngIf="mobile" class="mobile-list">
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'260'" [Cheight]="'50'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'260'" [Cheight]="'50'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'260'" [Cheight]="'50'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'260'" [Cheight]="'50'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'260'" [Cheight]="'50'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'260'" [Cheight]="'50'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'260'" [Cheight]="'50'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'260'" [Cheight]="'50'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'260'" [Cheight]="'50'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'260'" [Cheight]="'50'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'260'" [Cheight]="'50'" ></app-skeleton-loader>
  </div>
  <div class="list-item">
    <app-skeleton-loader [Cwidth]="'50'" [Cheight]="'50'" [circle]="true"></app-skeleton-loader>
    <app-skeleton-loader [Cwidth]="'260'" [Cheight]="'50'" ></app-skeleton-loader>
  </div>

</div>
